// extracted by mini-css-extract-plugin
export var container = "styles-module--container--GtAd7";
export var wrapper = "styles-module--wrapper--xXeIy";
export var itemContainer = "styles-module--itemContainer--u-k1r";
export var itemContent = "styles-module--itemContent--MP33z";
export var title = "styles-module--title--2UeQW";
export var itemImage = "styles-module--itemImage--EpIeY";
export var itemTitle = "styles-module--itemTitle--rT33r";
export var itemDescription = "styles-module--itemDescription--BZKUQ";